import GraphicStandOverviewSubPage from "./graphic-stand-overview-sub-page";


const SubPage = {
    OverView: GraphicStandOverviewSubPage,
};

export default SubPage;
